import {
    StyledAgendaAppointmentEvent,
    StyledAgendaAppointmentEventContent,
    StyledAgendaAppointmentEventParagraph,
    StyledAgendaAppointmentEventStatusIndicator,
    StyledAgendaAppointmentEventTitle
} from '@/features/agenda/components/agenda-appointment-event/style'
import {useTranslation} from '@/translations/i18n'
import {FallbackProps} from 'react-error-boundary'

export const AgendaAppointmentEventError = ({
    isSmall = false,
    error
}: Pick<FallbackProps, 'error'> & {isSmall?: boolean}) => {
    const {t} = useTranslation()

    return (
        <StyledAgendaAppointmentEvent $status={'missed'}>
            <StyledAgendaAppointmentEventStatusIndicator $status={'missed'} />
            <StyledAgendaAppointmentEventContent direction="column">
                <StyledAgendaAppointmentEventTitle>{t('errors:missing_data')}</StyledAgendaAppointmentEventTitle>
                {!isSmall && (
                    <>
                        <StyledAgendaAppointmentEventParagraph>{error.message}</StyledAgendaAppointmentEventParagraph>
                    </>
                )}
            </StyledAgendaAppointmentEventContent>
        </StyledAgendaAppointmentEvent>
    )
}
